import { Examples } from '@/types';

export const ExampleMStorePageRangeRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleMstorePageRange,
        components: {
          default: () => import(/* webpackChunkName: "ExampleMStorePageRange" */ 
          '@/views/examples/ExampleMStorePageRange.vue')
        }
      }
    ]
    : [];
